import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const testosteroneSupportEdQuestions = [
  {
    field: 'testosteroneSupportEd_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_height',
    label: 'What is your height in feet and inches?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'testosteroneSupportEd_height'
    }
  },
  {
    field: 'testosteroneSupportEd_weight',
    label: 'What is your weight in pounds?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'testosteroneSupportEd_weight'
    }
  },
  {
    field: 'testosteroneSupportEd_physicalExam',
    label:
      'Have you had a physical exam with a healthcare provider in the past 5 years?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes_goodHealth', value: 'Yes, I am in good health' },
        { key: 'yes_problems', value: 'Yes, but they found problems' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_physicalExam_issues',
    label: 'Please explain any issues during your last physical exam',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_physicalExam_issues'
    }
  },
  {
    field: 'testosteroneSupportEd_hospitalizations',
    label: 'Have you had any hospitalizations within the last year?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_hospitalizations_details',
    label: 'Please provide further details',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_hospitalizations_details'
    }
  },
  {
    field: 'testosteroneSupportEd_conditions',
    label:
      'Do any of the following conditions or situations apply to you? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'liverDisease', value: 'Liver disease' },
        { key: 'kidneyDisease', value: 'Chronic kidney disease' },
        { key: 'congestiveHeartFailure', value: 'Congestive heart failure' },
        { key: 'coronaryArteryDisease', value: 'Coronary artery disease' },
        {
          key: 'uncontrolledSleepApnea',
          value: 'Uncontrolled or untreated sleep apnea'
        },
        { key: 'historyOfBloodClot', value: 'History of a blood clot' },
        {
          key: 'testicularCancer',
          value: 'Testicular cancer (past or present)'
        },
        { key: 'prostateCancer', value: 'Prostate cancer (past or present)' },
        {
          key: 'pituitaryTumor',
          value: 'Tumor in the pituitary gland (past or present)'
        },
        {
          key: 'estrogenDependentTumor',
          value:
            'Estrogen-dependent tumor such as breast cancer or other (past or present)'
        },
        { key: 'earlyPuberty', value: 'Early puberty' },
        {
          key: 'gynecomastia',
          value: 'Gynecomastia (breast enlargement in men)'
        },
        {
          key: 'shrinkingTesticles',
          value: 'Shrinking testicles or small testes'
        },
        {
          key: 'signsOfEnlargedProstate',
          value:
            'Signs and symptoms of an enlarged prostate (increased urination at night, trouble starting urinary stream, urinating many times daily, urinary urgency, inability to pass urine, or weak urine flow)'
        },
        {
          key: 'none',
          uncheckOthers: true,
          value: 'None of the above'
        }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_conditions_details',
    label: 'Please tell us more about the condition(s) you selected',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_conditions_details'
    }
  },
  {
    field: 'testosteroneSupportEd_symptoms',
    label:
      'Have you experienced any of the following symptoms? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Decreased sex drive/libido', key: 'decreased_libido' },
        { value: 'Fatigue or lack of energy', key: 'fatigue' },
        {
          value: 'Mood changes like increased irritability or depression',
          key: 'mood_changes'
        },
        { value: 'Difficulty concentrating', key: 'difficulty_concentrating' },
        {
          value: 'Reduced muscle mass or strength',
          key: 'reduced_muscle'
        },
        { value: 'Increased body fat', key: 'increased_body_fat' },
        { value: 'Decreased body hair', key: 'decreased_body_hair' },
        {
          value: 'Decreased sense of well-being',
          key: 'decreased_wellbeing'
        },
        { value: 'Erectile dysfunction', key: 'erectile_dysfunction' },
        { value: 'Other', key: 'other' },
        {
          value: 'I do not experience any of these',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_symptomsDetails',
    label: 'Please tell us more about your symptoms',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_symptomsDetails'
    }
  },
  {
    field: 'testosteroneSupportEd_symptomsDuration',
    label: 'How long have you experienced the symptoms you selected?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 2,
      name: 'testosteroneSupportEd_symptomsDuration'
    }
  },
  {
    field: 'testosteroneSupportEd_previousTreatment',
    label: 'Have you ever been treated for hypogonadism or low testosterone?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_treatmentDetails',
    label:
      'Please provide more information, including your treatment (injections, gels, pellets, etc.) and approximate dates of treatment',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_treatmentDetails'
    }
  },
  {
    field: 'testosteroneSupportEd_previousComplications',
    label: 'Did you have any complications from treatment?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_previousSideEffects',
    label: 'Please tell us more about the side effects that you experienced',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_previousSideEffects'
    }
  },
  {
    field: 'testosteroneSupportEd_polycythemia',
    label:
      'Do you have polycythemia vera, an elevated blood count (hemoglobin/hematocrit), or has your provider recommended that you undergo phlebotomy (donate blood) for medical reasons?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_hypertension',
    label: 'Do you have hypertension (high blood pressure)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_bpControlled',
    label: 'Is your blood pressure well controlled?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_averageBP',
    label: 'What is your average blood pressure reading?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 1,
      name: 'testosteroneSupportEd_averageBP'
    }
  },
  {
    field: 'testosteroneSupportEd_tobacco',
    label: 'Do you smoke, vape, or use tobacco products?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_tobaccoFrequency',
    label: 'How often do you use these products?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'A few times per day', key: 'few_times_daily' },
        { value: 'Several times per day', key: 'several_times_daily' },
        { value: 'Weekly', key: 'weekly' },
        { value: 'Occasionally', key: 'occasionally' },
        { value: 'Rarely', key: 'rarely' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_alcohol',
    label: 'Do you consume alcohol?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_alcoholFrequency',
    label: 'How much and how often do you drink?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'I have 3 or more drinks per day', key: 'three_plus_daily' },
        { value: 'I have 1-2 drinks per day', key: 'one_two_daily' },
        { value: 'I have a few drinks per week', key: 'few_weekly' },
        { value: 'I will occasionally drink', key: 'occasionally' },
        { value: 'I rarely drink', key: 'rarely' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_exercise',
    label: 'Do you engage in regular physical exercise?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_contraindications',
    label:
      'Do you currently have, or have you ever experienced any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Diabetes', key: 'diabetes' },
        { value: 'HIV', key: 'hiv' },
        {
          value:
            'MI (heart attack), heart failure, cardiovascular disease, atherosclerosis',
          key: 'mi_heart_failure_cvd'
        },
        {
          value: 'Hypertrophic cardiomyopathy',
          key: 'hypertrophic_cardiomyopathy'
        },
        {
          value:
            'A heart arrhythmia (such as atrial fibrillation or QT prolongation)',
          key: 'heart_arrhythmia'
        },
        {
          value: 'Problems with excessive bleeding or clotting',
          key: 'bleeding_clotting'
        },
        { value: 'Stroke or brain hemorrhage', key: 'stroke' },
        {
          value: 'Disorders of blood cells or blood cancers',
          key: 'blood_disorders'
        },
        { value: 'Any other type of cancer', key: 'other_cancer' },
        { value: 'Retinitis pigmentosa', key: 'retinitis_pigmentosa' },
        { value: 'Pulmonary hypertension', key: 'pulmonary_hypertension' },
        { value: 'Gastrointestinal ulcers', key: 'gi_ulcers' },
        {
          value: 'Any history of radiation or chemotherapy',
          key: 'radiation_chemotherapy'
        },
        {
          value: 'No, I have never had any of these conditions',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_peyroniesDisease',
    label:
      'Do you have a marked curve or bend in the penis that interferes with sex, or Peyronie\'s Disease?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_activeBending',
    label:
      'Have you had active bending of your penis within the last 12 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_painWithErection',
    label: 'Do you experience pain with erections or with ejaculation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_tightForeskin',
    label: 'Do you have a foreskin that is too tight?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_cardiovascularSymptoms',
    label: 'Do you experience any of the following cardiovascular symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value:
            'Chest pain or shortness of breath when climbing 2 flights of stairs or walking 4 blocks',
          key: 'chest_pain_stairs'
        },
        {
          value: 'Chest pain or shortness of breath with sexual activity',
          key: 'chest_pain_sexual'
        },
        {
          value: 'Unexplained fainting or dizziness',
          key: 'fainting_dizziness'
        },
        {
          value: 'Prolonged cramping of the legs with exercise',
          key: 'leg_cramping'
        },
        { value: 'Abnormal heartbeats or rhythms', key: 'abnormal_heartbeat' },
        { value: 'None of those', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_illicitDrugUse',
    label: 'Do you use any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Poppers or Rush (Amyl Nitrate or Butyl Nitrate)',
          key: 'poppers'
        },
        { value: 'Cocaine', key: 'cocaine' },
        { value: 'Methamphetamine (crystal meth)', key: 'methamphetamine' },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_illicitDrugOtherDetails',
    label: 'Please provide further information',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_illicitDrugOtherDetails'
    }
  },
  {
    field: 'testosteroneSupportEd_additionalInfo',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'testosteroneSupportEd_additionalInfo'
    }
  },
  {
    field: 'testosteroneSupportEd_consentTruthfulness',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\nI verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'testosteroneSupportEd_consentTreatment',
    label: 'Consent (Exercise Optimization and Testosterone Support Treatment):',
    type: 'select',
    educationalSlide: `Introduction:
You have been prescribed a combination of medications to potentially enhance exercise performance, improve muscle growth and recovery, and support healthy testosterone levels. These medications may include agents that increase blood flow to your muscles and enclomiphene, which may help increase your natural testosterone production. While these medications are FDA-approved for other specific uses, their application for enhancing exercise performance or managing low testosterone symptoms in men is considered "off-label." This means that they are not specifically approved for these purposes, though your healthcare provider may prescribe them when deemed appropriate.

This consent form is provided to ensure that you understand the reasons for using these medications, their potential benefits and risks, the required monitoring plans, and your responsibilities as a patient. Please read this document carefully.

Purpose and Rationale:
You have been experiencing symptoms that may include fatigue, decreased libido, erectile dysfunction, mood changes, reduced muscle mass, and/or suboptimal exercise performance. These medications are being considered to:
- Enhance exercise performance, muscle growth, and recovery by improving blood flow and nutrient delivery to your muscles.
- Increase your body's natural testosterone production (through enclomiphene), potentially improving symptoms related to low or borderline testosterone levels, such as low energy, libido, and muscle strength.

The use of these medications for exercise optimization or testosterone support is considered off-label. Although legally prescribed, they are being used in a manner that differs from their original FDA-approved indications.

Potential Benefits:
Exercise and Performance-Enhancing Medications:
- Enhanced exercise performance, endurance, and capacity during workouts.
- Improved muscle growth (when combined with appropriate resistance training).
- Faster recovery and reduced muscle soreness between workouts.
- Better oxygen and nutrient delivery to muscles during exercise.

Enclomiphene:
- Increased natural testosterone production.
- Improved energy, mood, and libido.
- Enhanced sexual function.
- Increased muscle mass and strength.

Potential Risks and Side Effects:
Exercise and Performance-Enhancing Medications (e.g., vasodilators such as tadalafil, sildenafil, vardenafil, etc.):
Common Side Effects:
- Headache
- Flushing
- Nasal congestion
- Indigestion
- Muscle aches
- Back pain (more commonly reported with certain medications)
- Visual disturbances (e.g., blurred vision, changes in color perception)
Serious but Less Common Risks:
- Hypotension (significant drop in blood pressure)
- Cardiovascular events (heart attack, stroke, arrhythmias), especially in individuals with pre-existing heart conditions
- Priapism (prolonged erection in men, requiring medical attention)
- Hearing loss
- Vision loss (rare cases of non-arteritic anterior ischemic optic neuropathy, NAION)

Enclomiphene:
Common Risks:
- Increased risk of blood clots
- Mood changes
- Gynecomastia (breast tissue enlargement in men)
- Elevated red blood cell count
- Headaches, nausea, and visual disturbances
- Prostate enlargement
- Worsening of pre-existing sleep apnea
Serious but Less Common Risks:
- Exacerbation of undiagnosed prostate cancer
- Severe cardiovascular events (heart attack, stroke)
- Liver toxicity


Monitoring Plan:
To ensure your safety and the effectiveness of your treatment, regular monitoring will be required:
Baseline Testing:
- Review of current medications to identify potential interactions.
- Measurement of testosterone levels, liver function tests, and estradiol levels.
Ongoing Monitoring:
- Periodic blood tests to assess testosterone levels, blood counts, and other relevant markers.
- Assessments for side effects or adverse reactions related to both the exercise-enhancing medications and enclomiphene.
Symptom Assessment:
- Monitoring for any cardiovascular symptoms during exercise.
- Reporting any changes in vision, hearing, mood, or sexual function.
Follow-Up Visits:
- Scheduled appointments to discuss your progress, adjust the treatment plan as needed, and address any concerns.


Alternatives:
You have the right to consider alternative treatments, which may include:
Lifestyle Modifications:
- Optimizing nutrition, exercise regimen, and stress management.
- Ensuring adequate rest and recovery strategies.
Evidence-Based Supplements:
- Supplements known to support exercise performance and recovery (e.g., creatine).
Traditional Testosterone Replacement Therapy:
- Injections, gels, or patches to address low testosterone.


Patient Responsibilities:
As a patient, you are responsible for:
- Attending all scheduled follow-up appointments.
- Reporting any side effects or new symptoms to your healthcare provider immediately.
- Adhering to the prescribed dosing regimen and not adjusting the dose without consulting your healthcare provider.
- Undergoing all required laboratory tests and examinations as part of the monitoring plan.
- Informing your healthcare provider of all medications, supplements, and over-the-counter products you are taking.
- Avoiding the use of contraindicated substances or medications while on these treatments.


By selecting below, you understand the potential risks and benefits of using these medications and the off-label nature of this treatment. You agree to follow the monitoring plan and inform your healthcare provider of any side effects or concerns.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read and understand the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the information and wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    class: 'ineligible',
    field: 'testosteroneSupportEd_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    answer: {},
    type: 'info',
    reject: true,
    isLast: true,
    blockQuestionFlow: true,
  },
  {
    class: 'ineligible',
    field: 'testosteroneSupportEd_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true,
  },
  {
    field: 'testosteroneSupportEd_complete',
    isLast: true,
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  }
] as const;

export type TestosteroneSupportEdQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof testosteroneSupportEdQuestions>
>;
export default testosteroneSupportEdQuestions;
